import Vue from 'vue';
import axios from 'axios';
import getEnv from '@/utils/getEnv';

Vue.prototype.$http = axios;
export const  HTTP = axios.create({
    baseURL: getEnv('VUE_APP_API_URL'),
});
